import { Injectable } from '@angular/core';
import { HttpHeaders, HttpClient } from '@angular/common/http';
import { map } from "rxjs/operators";
import { AccesoService } from '../acceso/acceso.service';
import { environment } from '../../../environments/environment';
@Injectable({
  providedIn: 'root'
})
export class EmpresasService {
  dataPagare : any;
  pagareContrato:any;
  pagareDatos:any;
  razSocial : string;
  ruc: string;
  datos : any;
  tipoServicio : any;
  dataContratoMarco : any;
  addContactoEmpresa:boolean;
  codEmpresa : any;
  dataContratoM : any;
  user : any;
  idEmpresa_Factor : any;
  header : HttpHeaders;
  datosEmpresaSector : any;
  readonly urlBase =  environment.rutaBase;

  constructor( private http: HttpClient  , private accesoService :AccesoService) { 
    this.header = this.accesoService.desencriptarTOKEN();
  }

 

  obtenerIDEmpresa(){   
      this.idEmpresa_Factor= JSON.parse(sessionStorage.getItem('UserActive')).id_empresa; 
  }

  obtenerDepartamento() {
    this.obtenerIDEmpresa();
    let headers = this.header;
    return this.http.get(`${this.urlBase}/ubigeo/D?idEmpresa_Factor=${this.idEmpresa_Factor}`, {headers});
  }
  obtenerProvincia(idDepa) {
    this.obtenerIDEmpresa();
    let headers = this.header;
    return this.http.get(`${this.urlBase}/ubigeo/P?idEmpresa_Factor=${this.idEmpresa_Factor}&idDpto=${idDepa}`, { headers });
  }

  obtenerDistrito(idProv) {
    this.obtenerIDEmpresa();
    let headers = this.header;
    return this.http.get(`${this.urlBase}/ubigeo/S?idEmpresa_Factor=${this.idEmpresa_Factor}&idProv=${idProv}`, { headers });
  }

  obtenerListaProveedores(ruc? : string,user? : string){
    this.obtenerIDEmpresa();
    let headers = this.header;    
    return  this.http.get(`${this.urlBase}/empresas/pl?idEmpresa_Factor=${this.idEmpresa_Factor}&Num_Doc_Identificacion=${ruc}&Alta_Usuario=${user}`,{headers});
  }

  obtenerListaAdquirentes(ruc? : string,user? : string){
    this.obtenerIDEmpresa();
    let headers = this.header;
    return  this.http.get(`${this.urlBase}/empresas/al?idEmpresa_Factor=${this.idEmpresa_Factor}&Num_Doc_Identificacion=${ruc}&Alta_Usuario=${user}`,{headers});
  }
  obtenerListaFactor(ruc? : string,user? : string){
    this.obtenerIDEmpresa();
    let headers = this.header;
    return  this.http.get(`${this.urlBase}/empresas/fl?idEmpresa_Factor=${this.idEmpresa_Factor}&Num_Doc_Identificacion=${ruc}&Alta_Usuario=${user}`,{headers});
  }
  
  obtenerListaInversores(ruc? : string){
    this.obtenerIDEmpresa();
    let headers = this.header;
    return  this.http.get(`${this.urlBase}/empresas/il?idEmpresa_Factor=${this.idEmpresa_Factor}&Num_Doc_Identificacion=${ruc}`,{headers});
  }

  obtenerEmpresa(){
    this.obtenerIDEmpresa();
    let headers = this.header;

    return  this.http.get(`${this.urlBase}/empresas/g?idEmpresa_Factor=${this.idEmpresa_Factor}`,{headers});
  }

  obtenerProveedores(){
    this.obtenerIDEmpresa();
    let headers = this.header;
    return  this.http.get(`${this.urlBase}/empresas/p?idEmpresa_Factor=${this.idEmpresa_Factor}`,{headers});
  }

  obtenerProveedoresByRuc(ruc? : string){
    this.obtenerIDEmpresa()
    let headers = this.header;
    return  this.http.get(`${this.urlBase}/empresas/p?idEmpresa_Factor=${this.idEmpresa_Factor}&Ruc=${ruc}`,{headers});
  }

  obtenerAdquirenteByRuc(ruc? : string){
    this.obtenerIDEmpresa();
    let headers = this.header;

    return  this.http.get(`${this.urlBase}/empresas/a?idEmpresa_Factor=${this.idEmpresa_Factor}&Ruc=${ruc}`,{headers});
  }
  
  obtenerFactorByRuc(ruc? : string){
    this.obtenerIDEmpresa();
    let headers = this.header;

    return  this.http.get(`${this.urlBase}/empresas/f?idEmpresa_Factor=${this.idEmpresa_Factor}&Ruc=${ruc}`,{headers});
  }
  obtenerAdquirente(){
    this.obtenerIDEmpresa();
    let headers = this.header;

   return  this.http.get(`${this.urlBase}/empresas/a?idEmpresa_Factor=${this.idEmpresa_Factor}`,{headers})
        .pipe( 
          map ( (data) => {
                return data;
              }))
  }
  obtenerFactores(){
    this.obtenerIDEmpresa();
    let headers = this.header;

   return  this.http.get(`${this.urlBase}/empresas/f?idEmpresa_Factor=${this.idEmpresa_Factor}`,{headers})
        .pipe( 
          map ( (data) => {
                return data;
              }))
  }
  registrarEmpresa(empresa : any) {
    this.obtenerIDEmpresa();
    let headers = this.header;
    return this.http
    .post(`${this.urlBase}/empresa?idEmpresa_Factor=${this.idEmpresa_Factor}`,empresa,{headers})
      .pipe(
        map((data) => {
          return data;
        })
      );
  }

  obtenerAvalJuridico(){
    this.obtenerIDEmpresa();
    let headers = this.header;    
    return  this.http.get(`${this.urlBase}/empresas/jl?idEmpresa_Factor=${this.idEmpresa_Factor}`,{headers})
  }

  actualizarEmpresa(idempresa:string, empresa : any){
    this.obtenerIDEmpresa();
    let headers = this.header; 

    return this.http.put(`${this.urlBase}/empresa/${idempresa}?idEmpresa_Factor=${this.idEmpresa_Factor}`,empresa,{headers})
      .pipe(
        map((data) => {
          return data;
        })
      );
  }

  actualizarEstadoEmpresa(idempresa:string, empresa : any){
    this.obtenerIDEmpresa();
    let headers = this.header; 
    return this.http.put(`${this.urlBase}/empresa/estado/${idempresa}?idEmpresa_Factor=${this.idEmpresa_Factor}`, empresa, { headers });  
  }

  actualizarEmpresaBloqueo( body : any){
    this.obtenerIDEmpresa();
    let headers = this.header; 
    return this.http
      .post(`${this.urlBase}/empresa/bloqueo?idEmpresa_Factor=${this.idEmpresa_Factor}`,body,{headers})
      .pipe(
        map((data) => {
          return data;
        })
      );
  }
  
  //! CONTATCTOS
  obtenerContactosEmpresa(idEmpresa : any){
     this.obtenerIDEmpresa();
    let headers = this.header;
    return  this.http.get(`${this.urlBase}/contactoxempresa?idEmpresa_Factor=${this.idEmpresa_Factor}&idEmpresa=${idEmpresa}`,{headers})
   }

  obtenerContacto(idContacto : any){
    this.obtenerIDEmpresa();
     let headers = this.header;
     return  this.http.get(`${this.urlBase}/empresa/contacto?idEmpresa_Factor=${this.idEmpresa_Factor}&idContacto=${idContacto}`,{headers})
    }

  agregarContacto(body : any){
    this.obtenerIDEmpresa();
    let headers = this.header;
   return  this.http.post(`${this.urlBase}/empresa/contacto?idEmpresa_Factor=${this.idEmpresa_Factor}`,body,{headers})
        .pipe( 
          map ( (data) => {
                return data;
              }))
  }

  actualizarContacto(idContacto: string,body : any){
    this.obtenerIDEmpresa();
    let headers = this.header;

    return  this.http.put(`${this.urlBase}/empresa/contacto/${idContacto}?idEmpresa_Factor=${this.idEmpresa_Factor}`,body,{headers})
         .pipe( 
           map ( (data) => {
                 return data;
               }))
  }
  eliminarContacto(idContacto : number){
    this.obtenerIDEmpresa();
    let headers = this.header;
    
    let user = JSON.parse(sessionStorage.getItem('UserActive'));
   return  this.http.delete(`${this.urlBase}/empresa/contacto/${idContacto}?idEmpresa_Factor=${this.idEmpresa_Factor}&Baja_Usuario=${user.Usuario}`,{headers})
        .pipe( 
          map ( (data) => {
                return data;
              }))
  } 

  agregarAdjuntoEmpresa(body : any){
    this.obtenerIDEmpresa();
    let headers = this.header;

    return  this.http.put(`${this.urlBase}/empresa/adjunto/FR`,body,{headers})
         .pipe( 
           map ( (data) => {
                 return data;
               }))
  }

  agregarAdjunto(body : any){
    this.obtenerIDEmpresa();
    let headers = this.header;
    return  this.http.put(`${this.urlBase}/empresa/contacto/adjunto/VP?idEmpresa_Factor=${this.idEmpresa_Factor}`,body,{headers})
         .pipe( 
           map ( (data) => {
                 return data;
               }))
  }

  agregarAdjuntoDinamico(body : any){
    this.obtenerIDEmpresa();
   let headers = this.header;

    return  this.http.post(`${this.urlBase}/empresa/adjunto?idEmpresa_Factor=${this.idEmpresa_Factor}`,body,{headers})
         .pipe( 
           map ( (data) => {
                 return data;
               }))

  }
  
  bajaAdjuntoDinamico(data:any){
    let headers = this.header;
    return this.http.put(`${this.urlBase}/empresaDinamico?idEmpresa_Factor=${this.idEmpresa_Factor}`,data,{headers})
}
  

  obtenerAdjuntosEmpresa(idEmpresa:any){
    this.obtenerIDEmpresa();
    let headers = this.header;

   return  this.http.get(`${this.urlBase}/empresa/adjunto?idEmpresa_Factor=${this.idEmpresa_Factor}&idEmpresa=${idEmpresa}`,{headers})
        .pipe( 
          map ( (data) => {
                return data;
              }))
  }

  agregarAdjuntoDNI(body : any){
    this.obtenerIDEmpresa();
    let headers = this.header;

    return  this.http.put(`${this.urlBase}/empresa/contacto/adjunto/DNI?idEmpresa_Factor=${this.idEmpresa_Factor}`,body,{headers})
         .pipe( 
           map ( (data) => {
                 return data;
               }))
  }

  //! REFERENCIAS BANCARIAS
  obtenerReferenciasBancariasEmpresa(id : string){
    this.obtenerIDEmpresa();
    let headers = this.header;
    return this.http
      .get(`${this.urlBase}/empresa/CuentaBancariaEmpresa?idEmpresa_Factor=${this.idEmpresa_Factor}&idEmpresa=${id}`,{headers})
      .pipe(
        map((data) => {
          return data;
        })
      );
  }

  obtenerReferenciasBancariasEmpresaXID(idCuenta : any){
    this.obtenerIDEmpresa();
    let headers = this.header;
    return this.http.get(`${this.urlBase}/empresa/cuenta-bancaria?idEmpresa_Factor=${this.idEmpresa_Factor}&idCuenta=${idCuenta}`,{headers}).pipe( 
      map ( (data) => {
            return data;
          }));     
  }    

  agregarReferenciaBancaria(body : string){
    this.obtenerIDEmpresa();
    let headers = this.header;

   return  this.http.post(`${this.urlBase}/empresa/cuenta-bancaria?idEmpresa_Factor=${this.idEmpresa_Factor}`,body,{headers})
        .pipe( 
          map ( (data) => {
                return data;
              }))
  }

  editarReferenciaBancaria(body : string,idReferencia : string){
    this.obtenerIDEmpresa();
    let headers = this.header;

   return  this.http.put(`${this.urlBase}/empresa/cuenta-bancaria/${idReferencia}?idEmpresa_Factor=${this.idEmpresa_Factor}`,body,{headers})
        .pipe( 
          map ( (data) => {
                return data;
              }))
  }
  cambiarCuentaPredeterminada(body : string,idCuenta : string){
    this.obtenerIDEmpresa();
    let headers = this.header;

    return  this.http.put(`${this.urlBase}/empresa/cuenta/${idCuenta}?idEmpresa_Factor=${this.idEmpresa_Factor}`,body,{headers})
         .pipe( 
           map ( (data) => {
                 return data;
               }))
  }

  eliminarReferenciaBancaria(idReferencia : string){
    this.obtenerIDEmpresa();
    let headers = this.header;
   return  this.http.delete(`${this.urlBase}/empresa/cuenta-bancaria/${idReferencia}?idEmpresa_Factor=${this.idEmpresa_Factor}`,{headers})
        .pipe( 
          map ( (data) => {
                return data;
              }))
  }

  //! CONTRATOS MARCO
  
  obtenerContratosMarco(idEmpresa:any,tipoServicio:any){
    this.obtenerIDEmpresa();
    let headers = this.header;
    return this.http
      .get(`${this.urlBase}/empresa/contrato-marco?idEmpresa_Factor=${this.idEmpresa_Factor}&idEmpresa=${idEmpresa}&Tipo_Servicio=${tipoServicio}`,{headers})
      .pipe(
        map((data) => {
          return data;
        })
      );
  }

  updatePagare(body : string){
    let headers = this.header;
     return  this.http.post(`${this.urlBase}/AltaPagareAdj?idEmpresa_Factor=${this.idEmpresa_Factor}`,body,{headers}).pipe( map ( (data) => {return data;}))
    }

  updateContratoMarco(body : string){
    this.obtenerIDEmpresa();
  let headers = this.header;
   return  this.http.put(`${this.urlBase}/empresa/contrato-marco/adjunto?idEmpresa_Factor=${this.idEmpresa_Factor}`,body,{headers}).pipe( map ( (data) => {return data;}))
  }

  bajaContratoMarco(body : string){
    this.obtenerIDEmpresa();
    let headers = this.header;
     return  this.http.put(`${this.urlBase}/empresa/contrato-marco/baja?idEmpresa_Factor=${this.idEmpresa_Factor}`,body,{headers}).pipe( map ( (data) => {return data;}))

    }
  
  guardarContratoMarco(body : string){
    this.obtenerIDEmpresa();
    let headers = this.header;

    return  this.http
    .post(`${this.urlBase}/empresa/contrato-marco?idEmpresa_Factor=${this.idEmpresa_Factor}`,body,{headers})
        .pipe( 
          map ( (data) => {
                return data;
        }))
  }

  obtenerConfigConfirming(IDCMarco:any){
    this.obtenerIDEmpresa();
    let headers = this.header;

   return  this.http.get(`${this.urlBase}/empresa/contrato-marco/configuracion?idEmpresa_Factor=${this.idEmpresa_Factor}&IDCMarco=${IDCMarco}`,{headers})
        .pipe( 
          map ( (data) => {
                return data;
              }))
  }

  actualizarConfigConfirming(body : any){
    this.obtenerIDEmpresa();
    let headers = this.header;
    return  this.http.put(`${this.urlBase}/empresa/contrato-marco/configuracion?idEmpresa_Factor=${this.idEmpresa_Factor}`,body,{headers})
         .pipe( 
           map ( (data) => {
                 return data;
               }))
  }

  obtenerPersonaRiesgo(body : any){
    this.obtenerIDEmpresa();
    let headers = this.header;

   return  this.http.post(`${this.urlBase}/ObtenerDNI?idEmpresa_Factor=${this.idEmpresa_Factor}`,body,{headers})
        .pipe( 
          map ( (data) => {
                return data;
              }))
  }

  ListadoPagares(idEmpresa :any, tipoServicio : any, fechaIni: any, fechaFin : any){
    this.obtenerIDEmpresa();
    let headers = this.header;
    return  this.http.get(`${this.urlBase}/Pagare?idEmpresa_Factor=${this.idEmpresa_Factor}&idEmpresa=${idEmpresa}&Tipo_Servicio=${tipoServicio}&FechaIni=${fechaIni}&FechaFin=${fechaFin}`,{headers})                     
}

ListadoContratoM( Tipo : any, Fecha_Inicio : any, Fecha_Fin : any){
  this.obtenerIDEmpresa();
  let headers = this.header;
  return this.http
    .get(`${this.urlBase}/empresa/contrato-marco?idEmpresa_Factor=${this.idEmpresa_Factor}&Tipo_Servicio=${Tipo}&FechaInicio=${Fecha_Inicio}&FechaFin=${Fecha_Fin}`,{headers})
    .pipe(
      map((data) => {
        return data;
      })
    );        
}

ListadoContratoMvacio(idEmpresa_Factor? : number){
  this.obtenerIDEmpresa();
  let headers = this.header;
  return this.http.get(`${this.urlBase}/empresa/contrato-marco?idEmpresa_Factor=${this.idEmpresa_Factor}`,{headers})
    .pipe(
      map((data) => {
        return data;
      })
    );      
}

BajaPagare(body:any){
  this.obtenerIDEmpresa();
  let headers = this.header;

  return  this.http.put(`${this.urlBase}/Pagare/${body.idPagare}?idEmpresa_Factor=${this.idEmpresa_Factor}`,body,{headers}) 
       .pipe( 
         map ( (data) => {
               return data;
             }))      
 }

 CrearPagare(body:any){
  this.obtenerIDEmpresa();
  let headers = this.header; 
  return  this.http.post(`${this.urlBase}/Pagare?idEmpresa_Factor=${this.idEmpresa_Factor}`,body,{headers})
  .pipe( 
    map ( (data) => {
          return data;
        }))  
 }

 guardarLogo(body:any){
  this.obtenerIDEmpresa();
  let headers = this.header; 

  return  this.http.post(`${this.urlBase}/GuardarLogo?idEmpresa_Factor=${this.idEmpresa_Factor}`,body,{headers})
  .pipe( 
   map ( (data) => {
          return data;
        })) 
 }

 
}
